export enum ExperienceType {
	UNIFIED_HELP = 'unified-help',
}

export type DeepPartial<T> = T extends object
	? {
			[P in keyof T]?: DeepPartial<T[P]>;
		}
	: T;
